import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listAllTenants } from '../modules/tenantdata';
import { Grid, CircularProgress } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Footer from '../main/footer';
import { useTranslation } from 'react-i18next';

const styles = {
    table: { width: '100%', mb: '20px' },
    paper: { p: '5px' },
};

export default function TenantCompanyManagementView(props) {
    const tenants = useSelector((state) => state.tenantdata.allTenants);
    const isFetching = useSelector((state) => state.tenantdata.isFetchingAllTenants);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (props.active && (!tenants || tenants.length === 0)) {
            dispatch(listAllTenants());
        }
    }, [props.active, dispatch, tenants]);

    const openTenant = (tenantId) => {
        props.history.push('/admin/tenantcompany/edit/' + tenantId);
    };

    const onCreate = () => {
        props.history.push('/admin/tenantcompany/edit/new');
    };

    if (isFetching && (!tenants || tenants.length === 0)) {
        return (
            <Grid item xs={12}>
                <Paper sx={styles.paper}>
                    {t('general.retrievingInformation')}
                    <CircularProgress color={'secondary'} size={'1rem'} />
                </Paper>
            </Grid>
        );
    }

    return (
        <Grid item xs={12}>
            <Paper sx={styles.paper}>
                <h4>{t('admin.tenantCompanies')}</h4>
                <Table sx={styles.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('general.tenant')}</TableCell>
                            <TableCell>{t('admin.currency')}</TableCell>
                            <TableCell>{t('admin.orgNumber')}</TableCell>
                            <TableCell>{t('admin.orderNumberPrefix')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(tenants || []).map((tenant) => (
                            <TableRow
                                sx={{ '&:hover': { cursor: 'pointer', backgroundColor: 'lightgray', textDecoration: 'underline' } }}
                                key={tenant.id}
                                onClick={() => openTenant(tenant.id)}>
                                <TableCell>{tenant.name}</TableCell>
                                <TableCell>{tenant.currency}</TableCell>
                                <TableCell>{tenant.orgNumber}</TableCell>
                                <TableCell>{tenant.orderNumberPrefix}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
            <Footer>
                <Grid item>
                    <Button variant="contained" color="primary" name="newTenantCompany" onClick={onCreate}>
                        <i className="fas fa-file"></i>
                        &nbsp;{t('admin.newTenantCompany')}
                    </Button>
                </Grid>
            </Footer>
        </Grid>
    );
}
